import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { FaCheckCircle, FaHospital, FaUser, FaFileMedical, FaPhone, FaArrowRight, FaNotesMedical, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Insurances = () => {
  const [activeTab, setActiveTab] = useState(' TPA');
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  // List of Insurance Companies / TPAs Empanelled with Columbiaa Hospital
  const insuranceCompaniesList = [
    "Aditya Birla Health Insurance Company Limited",
    "AKNA Health Insurance TPA Private Limited",
    "Galaxy Health Insurance TPA Private Limited",
    "Go Digit General Insurance Limited",
    "Health Assist Insurance TPA Private Limited",
    "IFFCO Tokio General Insurance Company Limited",
    "Manipal Cigna Health Insurance Company Limited",
    "Tata AIG General Insurance Company Limited",
    "Vidal Health Insurance TPA Private Limited"
  ];

  // Images from insurances folder
  const insuranceImages = [
    { name: "Aditya Birla Health Insurance", src: "assets/images/insurances/Aditya Birla Health Insurance.png" },
    { name: "Acko General Insurance", src: "assets/images/insurances/Acko General Insurance.png" },
    { name: "Bajaj Allianz General Insurance", src: "assets/images/insurances/Bajaj Allianz General Insurance.jpg" },
    { name: "Care Health Insurance", src: "assets/images/insurances/care_health_insurance.png" },
    { name: "East West Assist Insurance TPA", src: "assets/images/insurances/East West Assist Insurance TPA.jpg" },
    { name: "Family Health Plan (FHPL)", src: "assets/images/insurances/Family Health Plan (FHPL).png" },
    { name: "Go Digit General Insurance", src: "assets/images/insurances/Go Digit General Insurance.png" },
    { name: "Good Health Insurance TPA", src: "assets/images/insurances/Good Health Insurance TPA.png" },
    { name: "Health India Insurance TPA", src: "assets/images/insurances/12. Health India Insurance TPA Services Pvt. Ltd..png" },
    { name: "HDFC ERGO General Insurance", src: "assets/images/insurances/5. HDFC ERGO General Insurance Co. Ltd..jpg" },
    { name: "ICICI Lombard General Insurance", src: "assets/images/insurances/6. ICICI Lombard General Insurance Co. Ltd..jpg" },
    { name: "IFFCO Tokio General Insurance", src: "assets/images/insurances/7. IFFCO Tokio General Insurance Co. Ltd..png" },
    { name: "Liberty General Insurance", src: "assets/images/insurances/8. Liberty General Insurance Limited.png" },
    { name: "ManipalCigna Health Insurance", src: "assets/images/insurances/10. ManipalCigna Health Insurance Co. Ltd..jpg" },
    { name: "MDIndia Healthcare Services TPA", src: "assets/images/insurances/MDIndia Healthcare Services TPA.png" },
    { name: "Medi Assist India", src: "assets/images/insurances/Medi Assist India.png" },
    { name: "MedSave Health Insurance TPA", src: "assets/images/insurances/MedSave Health Insurance TPA Ltd..png" },
    { name: "National Insurance", src: "assets/images/insurances/National Insurance.png" },
    { name: "Niva Bupa Health Insurance", src: "assets/images/insurances/nivabupaMobileLogo.png" },
    { name: "Paramount Health Services & Insurance TPA", src: "assets/images/insurances/Paramount Health Services & Insurance TPA.png" },
    { name: "Park Mediclaim Insurance TPA", src: "assets/images/insurances/14. Park Mediclaim Insurance TPA Pvt. Ltd..png" },
    { name: "Raksha Health Insurance TPA", src: "assets/images/insurances/Raksha Health Insurance TPA.jpg" },
    { name: "Safeway Insurance TPA", src: "assets/images/insurances/Safeway Insurance TPA Pvt..png" },
    { name: "SBI General Insurance", src: "assets/images/insurances/13. SBI General Insurance Company Ltd..jpg" },
    { name: "Star Health & Allied Insurance", src: "assets/images/insurances/Star Health & Allied Insurance.png" },
    { name: "Tata AIG General Insurance", src: "assets/images/insurances/Tata AIG General Insurance.jpg" },
    { name: "The New India Assurance", src: "assets/images/insurances/16. The New India Assurance Co. Ltd..jpg" },
    { name: "The Oriental Insurance", src: "assets/images/insurances/17. The Oriental Insurance Co. Ltd..png" },
    { name: "United India Insurance", src: "assets/images/insurances/18. United India Insurance Co. Ltd..png" },
    { name: "Vidal Health Insurance TPA", src: "assets/images/insurances/Vidal Health Insurance TPA.png" }
  ];

  // Accordion data for Insurance Companies & TPAs
  const insuranceFAQs = [
    {
      question: "Aditya Birla Health Insurance Company Limited",
      subItems: [
        { name: "Ericson Insurance TPA Private Limited" },
        { name: "Family Health Plan Insurance TPA Limited (FHPL)" },
        { name: "Good Health Insurance TPA Limited" },
        { name: "Health India Insurance TPA Services Private Limited" },
        { name: "MD India Health Insurance TPA Private Limited" },
        { name: "Medi Assist Insurance TPA Private Limited" },
        { name: "MedSave Health Insurance TPA Limited" },
        { name: "Paramount Health Services & Insurance TPA Private Limited" },
        { name: "Park Mediclaim Insurance TPA" },
        { name: "Safeway Insurance TPA Private Limited" },
        { name: "Vidal Health Insurance TPA Private Limited" },
        { name: "Volo Health TPA Private Limited" }
      ]
    },
    {
      question: "AKNA TPA – Associated Insurance Companies",
      subItems: [
        { name: "Acko General Insurance Limited" },
        { name: "Aditya Birla Health Insurance Company Limited" },
        { name: "Bajaj Allianz General Insurance Company Limited" },
        { name: "Care Health Insurance Limited" },
        { name: "Future Generali India Insurance Company Limited" },
        { name: "Go Digit General Insurance Limited" },
        { name: "HDFC ERGO General Insurance Company Limited" },
        { name: "ICICI Lombard General Insurance Company Limited" },
        { name: "IFFCO Tokio General Insurance Company Limited" },
        { name: "Liberty General Insurance Company Limited" },
        { name: "National Insurance Company Limited" },
        { name: "Niva Bupa Health Insurance Company Limited" },
        { name: "Star Health & Allied Insurance Company Limited" },
        { name: "Tata AIG General Insurance Company Limited" },
        { name: "The New India Assurance Company Limited" },
        { name: "The Oriental Insurance Company Limited" },
        { name: "United India Insurance Company Limited" }
      ]
    },
    {
      question: "Galaxy Health Insurance",
      subItems: [
        { name: "East West Assist Insurance TPA Private Limited (Volo TPA)" },
        { name: "Family Health Plan Insurance TPA Limited (FHPL)" },
        { name: "MD India Health Insurance TPA Private Limited" },
        { name: "Medi Assist Insurance TPA Private Limited" },
        { name: "Paramount Health Services TPA Private Limited" },
        { name: "Safeway Insurance TPA Private Limited" },
        { name: "Vidal Health Insurance TPA Private Limited" }
      ]
    },
    {
      question: "Go Digit General Insurance Limited",
      subItems: [
        { name: "Anmol Medicare Insurance TPA Limited" },
        { name: "East West Assist Insurance TPA Limited" },
        { name: "Ericson Insurance TPA Private Limited" },
        { name: "Family Health Plan Insurance TPA Limited (FHPL)" },
        { name: "Genins India Insurance TPA Limited" },
        { name: "Good Health Insurance TPA Limited" },
        { name: "Health India Insurance TPA Services Private Limited" },
        { name: "Health Insurance TPA of India Limited" },
        { name: "Heritage Health Services TPA Private Limited" },
        { name: "MD India Health Insurance TPA Private Limited" },
        { name: "MedAdvantage Insurance TPA Private Limited" },
        { name: "Medi Assist Insurance TPA Private Limited" },
        { name: "MedSave Health Insurance TPA Limited" },
        { name: "Paramount Health Services & Insurance TPA Private Limited" },
        { name: "Park Mediclaim Insurance TPA Private Limited" },
        { name: "Raksha Health Insurance TPA Private Limited" },
        { name: "Rothshield Insurance TPA Limited" },
        { name: "Safeway Insurance TPA Private Limited" },
        { name: "Vidal Health Insurance TPA Private Limited" }
      ]
    },
    {
      question: "Health Assist TPA Insurance (Formerly Safeway Insurance)",
      subItems: [
        { name: "Aditya Birla Health Insurance Company Limited" },
        { name: "Bajaj Allianz General Insurance Company Limited" },
        { name: "Care Health Insurance Limited (formerly Religare Health Insurance)" },
        { name: "Future Generali India Insurance Company Limited" },
        { name: "HDFC ERGO General Insurance Company Limited" },
        { name: "ICICI Lombard General Insurance Company Limited" },
        { name: "IFFCO Tokio General Insurance Company Limited" },
        { name: "Liberty General Insurance Limited" },
        { name: "Magma HDI General Insurance Company Limited" },
        { name: "Manipal Cigna Health Insurance Company Limited" },
        { name: "National Insurance Company Limited" },
        { name: "Niva Bupa Health Insurance Company Limited" },
        { name: "SBI General Insurance Company Limited" },
        { name: "Star Health & Allied Insurance Company Limited" },
        { name: "Tata AIG General Insurance Company Limited" },
        { name: "The New India Assurance Company Limited" },
        { name: "The Oriental Insurance Company Limited" },
        { name: "United India Insurance Company Limited" }
      ]
    },
    {
      question: "IFFCO-TOKIO Health Insurance Company Limited",
      subItems: [
        { name: "Family Health Plan Insurance TPA Limited (FHPL)" },
        { name: "Good Health Insurance TPA Limited" },
        { name: "MD India Health Insurance TPA Private Limited" },
        { name: "Medi Assist Insurance TPA Private Limited" },
        { name: "MedSave Health Insurance TPA Limited" },
        { name: "Vidal Health Insurance TPA Private Limited" }
      ]
    },
    {
      question: "Manipal Cigna Health Insurance Company Limited",
      subItems: [
        { name: "East West Assist Insurance TPA Private Limited (Volo Health TPA)" },
        { name: "Family Health Plan (FHPL) Insurance TPA Limited" },
        { name: "Health India Insurance TPA Services Private Limited" },
        { name: "MD India Health Insurance TPA Private Limited" },
        { name: "Medi Assist Insurance TPA Private Limited" },
        { name: "Paramount Health Services TPA Private Limited" },
        { name: "Safeway Insurance TPA Private Limited" },
        { name: "Vidal Health Insurance TPA Private Limited" }
      ]
    },
    {
      question: "SBI General Insurance Company Limited",
      subItems: []
    },
    {
      question: "TATA AIG Health Insurance",
      subItems: [
        { name: "East West Assist Insurance TPA" },
        { name: "Ericson Insurance TPA" },
        { name: "Family Health Plan Insurance TPA (FHPL)" },
        { name: "Good Health Insurance TPA" },
        { name: "Health India Insurance TPA" },
        { name: "Health Insurance TPA of India" },
        { name: "MDIndia Healthcare Services TPA" },
        { name: "Medi Assist India" },
        { name: "MedSave Health Insurance TPA" },
        { name: "Park Mediclaim Insurance TPA" },
        { name: "Paramount Health Services & Insurance TPA" },
        { name: "Raksha Health Insurance TPA" },
        { name: "Safeway Insurance TPA" },
        { name: "United Health Care Parekh Insurance TPA" },
        { name: "Vidal Health Insurance TPA" },
        { name: "Vipul MedCorp Insurance TPA" }
      ]
    },
    {
      question: "Vidal Health Insurance TPA Private Limited",
      subItems: [
        { name: "Aditya Birla Health Insurance Company Limited" },
        { name: "Bajaj Allianz General Insurance Company Limited" },
        { name: "Care Health Insurance Limited" },
        { name: "Cholamandalam MS General Insurance Company Limited" },
        { name: "Future Generali India Insurance Company Limited" },
        { name: "HDFC ERGO General Insurance Company Limited" },
        { name: "ICICI Lombard General Insurance Company Limited" },
        { name: "IFFCO Tokio General Insurance Company Limited" },
        { name: "Kotak Mahindra General Insurance Company Limited" },
        { name: "Magma HDI General Insurance Company Limited" },
        { name: "National Insurance Company Limited" },
        { name: "Reliance General Insurance Company Limited" },
        { name: "SBI General Insurance Company Limited" },
        { name: "Tata AIG General Insurance Company Limited" },
        { name: "The New India Assurance Company Limited" },
        { name: "The Oriental Insurance Company Limited" },
        { name: "United India Insurance Company Limited" }
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>Insurance & TPA Partners | Columbiaa Hospital Best Multi-Speciality Hospital Kasturi Nagar Bangalore</title>
        <meta name="description" content="Columbiaa Hospital, Kasturi Nagar, Bangalore accepts all major health insurance and TPA partners for cashless hospitalization. 50+ insurance companies, quick claim approval, 24/7 insurance helpdesk. Check if your insurance is accepted at our multi-speciality hospital." />
        <meta name="keywords" content="Columbiaa Hospital, health insurance, TPA partners, cashless hospitalization, cashless treatment, insurance claim, medical insurance, hospital insurance, health insurance Bangalore, cashless hospital Bangalore, insurance empanelled hospital, TPA network, insurance approval, pre-authorization, hospital cashless, Star Health, HDFC ERGO, ICICI Lombard, Bajaj Allianz, Tata AIG, New India Assurance, Oriental Insurance, United India Insurance, SBI General, Manipal Cigna, Care Health, Aditya Birla, Go Digit, Niva Bupa, insurance helpdesk, hospital insurance claim, cashless admission, corporate health insurance, Bajaj Allianz cashless, Best multi-speciality hospital Bangalore, hospital in Kasturi Nagar, hospital near me, Columbiaa Hospital insurance, 24/7 insurance support" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Insurance & TPA Partners | Columbiaa Hospital Best Multi-Speciality Hospital Kasturi Nagar Bangalore" />
        <meta property="og:description" content="Columbiaa Hospital accepts all major health insurance and TPA partners for cashless hospitalization in Kasturi Nagar, Bangalore. 50+ insurance companies, quick approval, 24/7 helpdesk." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/insurances" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/insurances" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>

      <section
        className="page-title py-5"
        style={{
          backgroundImage: "url(assets/images/background/page-title-2.jpg)",
          overflowX: "hidden",
        }}
        aria-label="Contact Page Banner"
      >
        <div
          className="pattern-layer"
          style={{
            backgroundImage: "url(assets/images/shape/pattern-35.png)",
          }}
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-12 col-md-10 text-center"
              data-aos="fade-right"
            >
              <div className="title-box my-4 my-md-0">
                <h1 className="display-4">Insurance & TPA Partners</h1>
                <p className="lead">Columbiaa Hospital – Your Health Care Partner in Kasturi Nagar, Bangalore.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cashless Treatment Services & Corporate Empanelment Section */}
      <section className="insurance-intro-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div className="row mb-5">
            <div className="col-12">
              <h2 className="text-center mb-4" style={{ color: '#007bff' }}>Cashless Treatment Services & Corporate Empanelment</h2>
              <h3 className="text-center mb-4" style={{ color: '#333', fontSize: '1.5rem' }}>List of Insurance Companies / TPAs Empanelled with Columbiaa Hospital</h3>
            </div>
          </div>

          {/* Insurance Companies List */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="row">
                    {insuranceCompaniesList.map((company, index) => (
                      <div key={index} className="col-md-6 mb-3">
                        <div className="d-flex align-items-center">
                          <FaCheckCircle className="text-success mr-2" />
                          <span>{company}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Columbiaa Hospital Empanelled With - Images */}
          <div className="row mb-5">
            <div className="col-12">
              <h3 className="text-center mb-4" style={{ color: '#333' }}>Columbiaa Hospital Empanelled With</h3>
            </div>
          </div>
          
          <div className="row mb-5">
            {insuranceImages.map((insurance, index) => (
              <div key={index} className="col-lg-2 col-md-3 col-sm-4 col-6 mb-4">
                <div className="card h-100 border-0 shadow-sm d-flex align-items-center justify-content-center p-3">
                  <img
                    src={insurance.src}
                    alt={`${insurance.name} logo`}
                    className="img-fluid"
                    loading="lazy"
                    style={{ maxHeight: '70px', objectFit: 'contain' }}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Accordion Section - Insurance Companies & TPAs */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <h3 className="text-center mb-4" style={{ color: '#333' }}>TPAs & Associated Insurance Companies</h3>
              
              <div className="accordion" id="insuranceAccordion">
                {insuranceFAQs.map((faq, index) => (
                  <div className="card shadow-sm mb-2 border" key={index}>
                    <div
                      className="card-header d-flex justify-content-between align-items-center"
                      onClick={() => toggleAccordion(index)}
                      style={{ cursor: 'pointer', backgroundColor: '#007bff', color: 'white' }}
                      aria-expanded={activeAccordion === index}
                      role="button"
                    >
                      <h4 className="mb-0 h6">{faq.question}</h4>
                      <span style={{ fontSize: '1.2em', transition: 'transform 0.3s' }}>
                        {activeAccordion === index ? '▲' : '▼'}
                      </span>
                    </div>
                    <div id={`insurance-body-${index}`} className={`collapse ${activeAccordion === index ? 'show' : ''}`}>
                      <div className="card-body" style={{ backgroundColor: '#f8f9fa' }}>
                        <ul className="list-unstyled">
                          {faq.subItems.map((item, subIndex) => (
                            <li key={subIndex} className="mb-2">
                              <FaCheckCircle className="text-primary mr-2" />
                              {item.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Existing Content - Features Section */}
      <section className="insurance-section py-5" aria-label="Insurance information section">
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-8 mx-auto text-center">
              <h2 className="mb-4" aria-label="Cashless Hospitalization heading">Cashless Hospitalization Made Easy</h2>
              <p className="lead" aria-label="Cashless hospitalization description">
                At <strong>Columbiaa Hospital, Kasturi Nagar</strong>, we understand that medical emergencies can be stressful.
                That is why we have partnered with over <strong>50+ TPAs</strong> and <strong>insurance companies</strong> to provide seamless cashless hospitalization services.
              </p>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-4 mb-4">
              <div className="card h-100 border-0 shadow-sm text-center p-4" role="article" aria-label="Cashless benefit feature">
                <div style={{ fontSize: '3rem', color: '#007bff' }} aria-hidden="true">
                  <FaHospital />
                </div>
                <h5 className="mt-3" aria-label="Cashless treatment heading">Cashless Treatment</h5>
                <p className="text-muted" aria-label="Cashless treatment description">
                  Avail cashless treatment at our hospital with our extensive network of insurance partners.
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100 border-0 shadow-sm text-center p-4" role="article" aria-label="Quick approval feature">
                <div style={{ fontSize: '3rem', color: '#007bff' }} aria-hidden="true">
                  <FaFileMedical />
                </div>
                <h5 className="mt-3" aria-label="Quick approval heading">Quick Approval</h5>
                <p className="text-muted" aria-label="Quick approval description">
                  Get your insurance approval within hours with our dedicated insurance helpdesk.
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100 border-0 shadow-sm text-center p-4" role="article" aria-label="24/7 support feature">
                <div style={{ fontSize: '3rem', color: '#007bff' }} aria-hidden="true">
                  <FaPhone />
                </div>
                <h5 className="mt-3" aria-label="24/7 support heading">24/7 Support</h5>
                <p className="text-muted" aria-label="24/7 support description">
                  Our insurance team is available round the clock to assist you with all queries.
                </p>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-lg-8 mx-auto">
              <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)' }}>
                <div className="card-body text-center text-white p-5">
                  <h3 className="mb-4" aria-label="Insurance claim process heading">Easy Insurance Claim Process</h3>
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <div className="text-center">
                        <div style={{ fontSize: '2rem', marginBottom: '10px' }} aria-hidden="true">
                          <FaFileMedical />
                        </div>
                        <h6 aria-label="Step 1: Submit documents">Step 1: Submit Documents</h6>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="text-center">
                        <div style={{ fontSize: '2rem', marginBottom: '10px' }} aria-hidden="true">
                          <FaCheckCircle />
                        </div>
                        <h6 aria-label="Step 2: Verification">Step 2: Verification</h6>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="text-center">
                        <div style={{ fontSize: '2rem', marginBottom: '10px' }} aria-hidden="true">
                          <FaHospital />
                        </div>
                        <h6 aria-label="Step 3: Approval">Step 3: Approval</h6>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3">
                      <div className="text-center">
                        <div style={{ fontSize: '2rem', marginBottom: '10px' }} aria-hidden="true">
                          <FaUser />
                        </div>
                        <h6 aria-label="Step 4: Treatment">Step 4: Treatment</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h3 className="mb-4" aria-label="Contact insurance team heading">Have Questions About Your Insurance?</h3>
              <p className="mb-4" aria-label="Insurance inquiry description">
                Our dedicated insurance helpdesk team is here to assist you with all your queries regarding insurance claims, pre-authorization, and coverage.
              </p>
              <div className="d-flex justify-content-center flex-wrap gap-3">
                <a href="tel:9108432694" className="btn btn-primary btn-lg" aria-label="Call Insurance Helpdesk">
                  <FaPhone className="mr-2" aria-hidden="true" /> Call: 9108432694
                </a>
                <a href="https://wa.me/919108432694" target="_blank" rel="noopener noreferrer" className="btn btn-success btn-lg" aria-label="WhatsApp Insurance Helpdesk">
                  <FaWhatsapp className="mr-2" aria-hidden="true" /> WhatsApp: 9108432694
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Insurances;
